import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, switchMap, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { inject } from '@angular/core';
import { AuthService } from '../../features/auth/services/auth.service';
import { Router } from '@angular/router';

export const JwtInterceptor: HttpInterceptorFn = (req, next) => {
  const toaster = inject(ToastrService);
  const service = inject(AuthService);
  const router = inject(Router);

  const authToken = localStorage.getItem('ShuwierToken');
  // const authToken = service.getAccessToken();
  // Don't intercept refresh request
  // if (req.url.includes('/auth/refresh')) {
  //   return next(req);
  // }
  // Fetch language using the TranslationService
  const authReq = req.clone({
    setHeaders: {
      Authorization: authToken ? `Bearer ${authToken}` : '',
      // lang: 'en',
    },
  });
  // const authReq = authToken
  //   ? req.clone({ setHeaders: { Authorization: `Bearer ${authToken}` } })
  //   : req;

  return next(authReq).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });

        if (err.status === 401) {
          const isLoginRequest = req.url.includes('/auth/login');
          const isLogoutRequest = req.url.includes('/auth/logout');
          const isRefreshRequest = req.url.includes('/auth/refresh');

          if (isLogoutRequest) {
            service.logoutLocal();
            router.navigate(['/login']);
          }
          if (isLoginRequest) {
            // if (isLoginRequest || isLogoutRequest) {
            return throwError(() => err);
          }
          // Refresh endpoint itself failed
          if (isRefreshRequest) {
            service.logoutLocal();
            router.navigate(['/login']);
            toaster.error('Session expired. Please login again.');
            return throwError(() => err);
          }

          const token = localStorage.getItem('ShuwierToken');
          // const token = service.getAccessToken();

          // No access token -> don't even try refresh
          if (!token) {
            console.log('from no token');

            service.logoutLocal();
            // router.navigate(['/auth/login']);
            toaster.error('Session expired. Please login again.');
            return throwError(() => err);
          } else if (token) {
            console.log('Token from 401 error', token);

            // Token exists -> try refresh
            return service.refreshAndUpdateSession().pipe(
              // Refresh succeeded
              switchMap(() => {
                service.firstPageAfterLogin();

                // No retry of the original request
                return throwError(() => err);
              })

              // Refresh failed
              // catchError((refreshError: HttpErrorResponse) => {

              //   service.logoutLocal();
              //   router.navigate(['/login']);
              //   toaster.error('Session expired. Please login again.');

              //   return throwError(() => refreshError);
              // })
            );
          }
          // service.logoutLocal();
          // toaster.error(err?.error?.message || 'Session Expired Please Login Again');
          // return throwError(() => err);
        }

        // toaster.error('', err.error.message );
      }
      return throwError(() => err);
    })
  );
};
